module.exports = __webpack_public_path__ + "img/operationCapacity3.8157df05.png";